<template>
    <div
        class="finance-options"
        data-qa="finance-options"
    >
        <AffirmWidget
            v-if="affirm"
            :refresh-key="Number(affirm.price.amount) * 100"
        >
            <p
                :data-amount="Number(affirm.price.amount) * 100"
                class="title affirm-as-low-as"
                data-page-type="product"
                data-qa="affirm"
            ></p>
        </AffirmWidget>
    </div>
</template>

<script lang="ts" setup>
import type { AffirmFinanceOptionsFragment } from '@/graphql/api'

import AffirmWidget from '@/components/rings/AffirmWidget.vue'

defineProps<{
    affirm: AffirmFinanceOptionsFragment | null | undefined
}>()
</script>

<style lang="scss" scoped>
.finance-options {
    .affirm-badge {
        background: url('@/assets/icons/affirm.svg') no-repeat;
        background-size: contain;
        display: inline-block;
        vertical-align: text-bottom;
        @include visually-hidden-text;

        height: 21px;
        width: 60px;
        margin-bottom: 10px;
    }
}
</style>
